/* ==========================================================================
   Baby Lov Knits — theme.js
   Cart drawer, product options, add-ons, sticky ATC, search, UI helpers
   ========================================================================== */
(function () {
  'use strict';

  var BLK = window.BLK = window.BLK || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Utilities ---------- */
  function formatMoney(cents) {
    var amount = (Number(cents) / 100).toFixed(2);
    var noDecimals = String(Math.round(Number(cents) / 100));
    var fmt = BLK.moneyFormat || '£{{ amount }}';
    return fmt
      .replace('{{ amount_with_comma_separator }}', amount.replace('.', ','))
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{ amount_no_decimals }}', noDecimals)
      .replace('{{amount_no_decimals}}', noDecimals)
      .replace('{{ amount }}', amount)
      .replace('{{amount}}', amount);
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function toast(message, isError) {
    var region = $('#ToastRegion');
    if (!region) return;
    var el = document.createElement('div');
    el.className = 'toast' + (isError ? ' toast--error' : '');
    el.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      (isError
        ? '<circle cx="12" cy="12" r="9"></circle><path d="M12 8v5"></path><path d="M12 16.5v.01"></path>'
        : '<path d="M20 6 9 17l-5-5"></path>') +
      '</svg><span>' + escapeHtml(message) + '</span>';
    region.appendChild(el);
    setTimeout(function () {
      el.style.transition = 'opacity .3s, transform .3s';
      el.style.opacity = '0';
      el.style.transform = 'translateY(8px)';
      setTimeout(function () { el.remove(); }, 320);
    }, 2800);
  }

  function lockScroll(lock) {
    document.body.classList.toggle('no-scroll', lock);
  }

  function postJSON(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data)
    }).then(function (res) {
      return res.json().then(function (json) { return { ok: res.ok, data: json }; });
    });
  }

  /* ---------- Header state ---------- */
  var header = $('.header');
  function onScroll() {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 8);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Announcement rotation ---------- */
  var announceItems = $$('[data-announcement-item]');
  if (announceItems.length > 1) {
    var ai = 0;
    setInterval(function () {
      announceItems[ai].classList.remove('is-active');
      ai = (ai + 1) % announceItems.length;
      announceItems[ai].classList.add('is-active');
    }, 4200);
  }

  /* ---------- Mobile navigation ---------- */
  var mobileNav = $('#MobileNav');
  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    lockScroll(true);
    var first = $('a, button', mobileNav);
    if (first) first.focus({ preventScroll: true });
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    lockScroll(false);
  }
  $$('[data-mobile-nav-open]').forEach(function (btn) { btn.addEventListener('click', openMobileNav); });
  $$('[data-mobile-nav-close]').forEach(function (btn) { btn.addEventListener('click', closeMobileNav); });
  if (mobileNav) {
    $$('a', mobileNav).forEach(function (a) { a.addEventListener('click', closeMobileNav); });
  }

  /* ---------- Search modal ---------- */
  var searchModal = $('#SearchModal');
  var searchInput = $('#SearchInput');
  function openSearch() {
    if (!searchModal) return;
    searchModal.classList.add('is-open');
    lockScroll(true);
    setTimeout(function () { if (searchInput) searchInput.focus(); }, 120);
  }
  function closeSearch() {
    if (!searchModal) return;
    searchModal.classList.remove('is-open');
    lockScroll(false);
  }
  $$('[data-search-open]').forEach(function (btn) { btn.addEventListener('click', openSearch); });
  $$('[data-search-close]').forEach(function (btn) { btn.addEventListener('click', closeSearch); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeSearch();
      closeMobileNav();
      closeCart();
    }
  });

  /* ---------- Cart drawer ---------- */
  var drawer = $('#CartDrawer');
  var drawerBody = $('#CartDrawerBody');
  var drawerFoot = $('#CartDrawerFoot');
  var cartCountEls = $$('[data-cart-count]');
  var cart = { items: [], item_count: 0, total_price: 0 };

  function setCartCount(count) {
    cartCountEls.forEach(function (el) {
      el.textContent = String(count);
      el.hidden = count === 0;
    });
  }

  function freeShipMarkup() {
    var threshold = Number(BLK.freeShippingThreshold || 0);
    var total = Number(cart.total_price || 0);
    var complete = threshold <= 0 || total >= threshold;
    var pct = threshold > 0 ? Math.min(100, Math.round((total / threshold) * 100)) : 100;
    var label = complete
      ? 'You unlocked <strong>FREE UK shipping</strong> on this order'
      : 'You are <strong>' + formatMoney(threshold - total) + '</strong> away from FREE UK shipping';
    return '<div class="free-ship' + (complete ? ' is-complete' : '') + '">' +
      '<div class="free-ship__label">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v10H3z"></path><path d="M14 10h4l3 3v4h-7z"></path><circle cx="7" cy="18" r="1.6"></circle><circle cx="17.5" cy="18" r="1.6"></circle></svg>' +
      '<span>' + label + '</span></div>' +
      '<div class="free-ship__bar"><div class="free-ship__fill" style="width:' + pct + '%"></div></div>' +
      '</div>';
  }

  function lineProps(props) {
    if (!props) return '';
    var out = '';
    Object.keys(props).forEach(function (key) {
      if (key.charAt(0) === '_') return;
      var val = props[key];
      if (val == null || val === '') return;
      out += '<div><strong>' + escapeHtml(key) + ':</strong> ' + escapeHtml(val) + '</div>';
    });
    return out;
  }

  function renderCart() {
    if (!drawerBody) return;
    setCartCount(cart.item_count || 0);

    if (!cart.items || cart.items.length === 0) {
      drawerBody.innerHTML = '<div class="drawer__empty">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 8h12l-1 12H7L6 8z"></path><path d="M9 8V6a3 3 0 0 1 6 0v2"></path></svg>' +
        '<h3>Your basket is empty</h3>' +
        '<p>Create a keepsake they will use every day.</p>' +
        '<a class="btn btn--primary" href="' + (BLK.allProductsUrl || '/collections/all') + '">Start shopping</a>' +
        '</div>';
      if (drawerFoot) drawerFoot.innerHTML = '';
      return;
    }

    var html = freeShipMarkup();
    cart.items.forEach(function (item) {
      var key = item.key || item.id;
      var img = typeof item.image === 'string' ? item.image : (item.image && item.image.src ? item.image.src : '');
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      html += '<div class="cart-line" data-line-key="' + escapeHtml(key) + '">' +
        '<div class="cart-line__media">' + (img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : '') + '</div>' +
        '<div class="cart-line__body">' +
        '<div class="cart-line__title">' + escapeHtml(item.product_title) + '</div>' +
        (variant ? '<div class="cart-line__variant">' + escapeHtml(variant) + '</div>' : '') +
        (lineProps(item.properties) ? '<div class="cart-line__props">' + lineProps(item.properties) + '</div>' : '') +
        '<div class="cart-line__row">' +
        '<div class="qty" data-line-qty>' +
        '<button type="button" data-qty-step="-1" data-key="' + escapeHtml(key) + '" aria-label="Decrease quantity"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M5 12h14"></path></svg></button>' +
        '<input type="number" min="0" value="' + Number(item.quantity) + '" data-cart-qty data-key="' + escapeHtml(key) + '" aria-label="Quantity">' +
        '<button type="button" data-qty-step="1" data-key="' + escapeHtml(key) + '" aria-label="Increase quantity"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M12 5v14M5 12h14"></path></svg></button>' +
        '</div>' +
        '<div class="cart-line__price">' + formatMoney(item.final_line_price) + '</div>' +
        '</div>' +
        '<button type="button" class="cart-line__remove" data-cart-remove="' + escapeHtml(key) + '">Remove</button>' +
        '</div></div>';
    });
    drawerBody.innerHTML = html;

    if (drawerFoot) {
      drawerFoot.innerHTML =
        '<div class="cart-summary-row"><span>Subtotal</span><strong>' + formatMoney(cart.total_price) + '</strong></div>' +
        '<div class="cart-summary-row"><span>Shipping</span><strong style="color:var(--success)">FREE</strong></div>' +
        '<div class="cart-summary-note">UK shipping is free on every order. Taxes calculated at checkout.</div>' +
        '<a href="/checkout" class="btn btn--primary btn--block cart-checkout" data-checkout>Checkout — ' + formatMoney(cart.total_price) + '</a>' +
        '<div class="cart-trust"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="10" width="16" height="10" rx="2"></rect><path d="M8 10V7a4 4 0 0 1 8 0v3"></path></svg>Secure checkout · 2-year name guarantee</div>' +
        '<a href="' + (BLK.cartUrl || '/cart') + '" class="cart-continue">View basket</a>';
    }
  }

  function refreshCart(open) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        cart = data;
        renderCart();
        if (open) openCart();
      })
      .catch(function () { /* silent */ });
  }

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    lockScroll(true);
    var closeBtn = $('[data-cart-close]', drawer);
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (!searchModal || !searchModal.classList.contains('is-open')) {
      if (!mobileNav || !mobileNav.classList.contains('is-open')) lockScroll(false);
    }
  }

  $$('[data-cart-open]').forEach(function (btn) { btn.addEventListener('click', function () { refreshCart(true); }); });
  $$('[data-cart-close]').forEach(function (btn) { btn.addEventListener('click', closeCart); });
  if (drawer) {
    var overlay = $('.drawer__overlay', drawer);
    if (overlay) overlay.addEventListener('click', closeCart);
  }

  /* Delegated cart actions */
  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      var key = removeBtn.getAttribute('data-cart-remove');
      postJSON(BLK.cartChangeUrl || '/cart/change.js', { id: key, quantity: 0 })
        .then(function () { return refreshCart(false); })
        .then(function () { toast('Item removed'); });
      return;
    }
    var stepBtn = e.target.closest('[data-qty-step]');
    if (stepBtn) {
      var k = stepBtn.getAttribute('data-key');
      var dir = Number(stepBtn.getAttribute('data-qty-step'));
      var line = document.querySelector('[data-line-key="' + k + '"]');
      var input = line ? $('[data-cart-qty]', line) : null;
      var next = Math.max(0, (input ? Number(input.value) : 1) + dir);
      if (input) input.value = next;
      postJSON(BLK.cartChangeUrl || '/cart/change.js', { id: k, quantity: next })
        .then(function () { return refreshCart(false); });
    }
  });

  document.addEventListener('change', function (e) {
    var qty = e.target.closest('[data-cart-qty]');
    if (qty) {
      var key = qty.getAttribute('data-key');
      var quantity = Math.max(0, Number(qty.value) || 0);
      postJSON(BLK.cartChangeUrl || '/cart/change.js', { id: key, quantity: quantity })
        .then(function () { return refreshCart(false); });
    }
  });

  /* ---------- Product form ---------- */
  var productForm = $('#ProductForm');
  var stickyAtc = $('#StickyAtc');

  function selectedVariantData() {
    if (!productForm) return null;
    var variantId = productForm.querySelector('[name="id"]');
    var variantsEl = productForm.querySelector('[data-variants]');
    if (!variantsEl) return null;
    var variants;
    try { variants = JSON.parse(variantsEl.textContent); } catch (err) { return null; }
    var id = Number(variantId ? variantId.value : 0);
    var found = null;
    for (var i = 0; i < variants.length; i++) { if (variants[i].id === id) { found = variants[i]; break; } }
    return found || variants[0] || null;
  }

  function updateVariantUI(variant) {
    if (!variant || !productForm) return;
    var priceEl = $('[data-product-price]', productForm);
    var compareEl = $('[data-product-compare]');
    var saveEl = $('[data-product-save]');
    var idInput = $('[name="id"]', productForm);
    var atcBtn = $('[data-atc-button]', productForm);
    var stickyBtn = $('[data-sticky-atc]');
    var stickyPrice = $('[data-sticky-price]');
    var stickySelected = $('[data-sticky-selected]');
    var mainImg = $('[data-gallery-main] img');

    if (idInput) idInput.value = variant.id;
    var optLabels = $$('[data-option-label]', productForm);
    var optVals = variant.options || [variant.option1, variant.option2, variant.option3];
    optLabels.forEach(function (lab, idx) { if (optVals[idx]) lab.textContent = optVals[idx]; });
    $$('[data-yarn-dropdown]', productForm).forEach(function (dd) {
      var pos = parseInt(dd.getAttribute('data-yarn-position') || '2', 10);
      var val = optVals[pos - 1]; if (!val) return;
      var row = dd.querySelector('[data-yarn-option][data-value="' + val + '"]');
      var cur = dd.querySelector('[data-yarn-current]'); if (cur) cur.textContent = val;
      var bs = dd.querySelector('[data-yarn-button] .swatch');
      if (bs && row) { var rs = row.querySelector('.swatch'); if (rs) bs.style.background = rs.style.background; }
    });
    if (priceEl) priceEl.innerHTML = formatMoney(variant.price) + (variant.compare_at_price && variant.compare_at_price > variant.price ? '<span class="price__compare"> ' + formatMoney(variant.compare_at_price) + '</span>' : '');
    if (compareEl) compareEl.textContent = variant.compare_at_price && variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : '';
    if (saveEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
        saveEl.hidden = false;
        saveEl.textContent = 'Save ' + pct + '%';
      } else {
        saveEl.hidden = true;
      }
    }
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
    if (stickySelected && variant.title && variant.title !== 'Default Title') stickySelected.textContent = variant.title;
    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      atcBtn.innerHTML = variant.available
        ? '<span>Add to basket</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"></path></svg>'
        : '<span>Sold out</span>';
    }
    if (stickyBtn) {
      stickyBtn.disabled = !variant.available;
      stickyBtn.textContent = variant.available ? 'Add to basket' : 'Sold out';
    }
    if (mainImg && variant.featured_image && variant.featured_image.src) {
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.src = variant.featured_image.src;
      mainImg.alt = variant.featured_image.alt || productForm.getAttribute('data-product-title') || '';
    }
    // URL sync
    if (history.replaceState && variant.id) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState(null, '', url.toString());
    }
  }

  function initProductForm() {
    if (!productForm) return;
    var variantsEl = $('[data-variants]', productForm);
    if (!variantsEl) return;
    var variants;
    try { variants = JSON.parse(variantsEl.textContent); } catch (err) { return; }

    var optionInputs = $$('[data-option-input]', productForm);
    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var selections = {};
        $$('[data-option-input]', productForm).forEach(function (el) {
          if (el.tagName === 'SELECT' || el.checked) {
            selections[el.getAttribute('data-option-name')] = el.value;
          }
        });
        var optionNames = [];
        $$('[data-option-input]', productForm).forEach(function (el) {
          var n = el.getAttribute('data-option-name');
          if (optionNames.indexOf(n) === -1) optionNames.push(n);
        });
        var match = null;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var vals = v.options || [v.option1, v.option2, v.option3];
          var ok = true;
          for (var j = 0; j < optionNames.length; j++) {
            if (selections[optionNames[j]] && vals[j] !== selections[optionNames[j]]) { ok = false; break; }
          }
          if (ok) { match = v; break; }
        }
        if (match) updateVariantUI(match);
      });
    });

    // Gallery
    $$('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        var mainImg = $('[data-gallery-main] img');
        if (mainImg && src) {
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = src;
          mainImg.alt = thumb.getAttribute('data-alt') || mainImg.alt;
        }
        $$('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    // Name preview
    var nameInput = $('[data-name-input]', productForm);
    var namePreview = $('[data-name-preview]', productForm);
    var nameCount = $('[data-name-count]', productForm);
    if (nameInput && namePreview) {
      var renderName = function () {
        var val = nameInput.value.trim();
        if (val) {
          namePreview.textContent = val;
          namePreview.classList.remove('is-empty');
        } else {
          namePreview.textContent = 'Their name here';
          namePreview.classList.add('is-empty');
        }
        if (nameCount) nameCount.textContent = val.length + '/11';
      };
      nameInput.addEventListener('input', renderName);
      renderName();
    }

    // Submit
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var variant = selectedVariantData();
      if (!variant) { toast('Please choose an option', true); return; }
      if (!variant.available) { toast('This option is sold out', true); return; }

      var nameField = $('[data-name-input]', productForm);
      var nameError = $('[data-name-error]', productForm);
      var nameWrap = nameField ? nameField.closest('.field') : null;
      if (nameField && nameField.hasAttribute('required') && !nameField.value.trim()) {
        if (nameWrap) nameWrap.classList.add('has-error');
        if (nameError) nameError.hidden = false;
        nameField.focus();
        toast('Please add the name to personalise', true);
        return;
      }
      if (nameWrap) nameWrap.classList.remove('has-error');
      if (nameError) nameError.hidden = true;

      var qtyInput = $('[name="quantity"]', productForm);
      var qty = Math.max(1, Number(qtyInput ? qtyInput.value : 1) || 1);
      var properties = {};
      $$('[data-property]', productForm).forEach(function (el) {
        var key = el.getAttribute('data-property');
        var val = (el.value || '').trim();
        if (val) properties[key] = val;
      });

      var items = [{
        id: variant.id,
        quantity: qty,
        properties: properties
      }];

      $$('[data-addon]:checked', productForm).forEach(function (addon) {
        var addonId = Number(addon.getAttribute('data-addon-variant-id'));
        if (addonId) items.push({ id: addonId, quantity: 1 });
      });

      var btn = $('[data-atc-button]', productForm);
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.classList.add('is-loading'); btn.disabled = true; btn.innerHTML = '<span>Adding…</span>'; }

      postJSON(BLK.cartAddUrl || '/cart/add.js', { items: items })
        .then(function (res) {
          if (!res.ok) throw new Error((res.data && res.data.description) || 'Could not add to basket');
          return refreshCart(true);
        })
        .then(function () {
          toast('Added to basket');
          if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; btn.innerHTML = original; }
        })
        .catch(function (err) {
          toast(err.message || 'Something went wrong', true);
          if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; btn.innerHTML = original; }
        });
    });

    // Sticky ATC visibility
    var mainAtc = $('[data-atc-button]', productForm);
    if (stickyAtc && mainAtc && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { rootMargin: '-80px 0px 0px 0px', threshold: 0 });
      obs.observe(mainAtc);
    } else if (stickyAtc) {
      stickyAtc.classList.add('is-visible');
    }

    // Dispatch / delivery estimate (UK)
    var dispatchEl = $('[data-dispatch-date]');
    var deliveryEl = $('[data-delivery-range]');
    if (dispatchEl || deliveryEl) {
      var now = new Date();
      var addWorkdays = function (date, days) {
        var d = new Date(date.getTime());
        var added = 0;
        while (added < days) {
          d.setDate(d.getDate() + 1);
          var day = d.getDay();
          if (day !== 0 && day !== 6) added++;
        }
        return d;
      };
      var dispatch = addWorkdays(now, 1);
      var from = addWorkdays(dispatch, 3);
      var to = addWorkdays(dispatch, 5);
      var opts = { weekday: 'short', day: 'numeric', month: 'short' };
      if (dispatchEl) dispatchEl.textContent = dispatch.toLocaleDateString('en-GB', opts);
      if (deliveryEl) deliveryEl.textContent = from.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }) + ' – ' + to.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
    }
  }

  /* ---------- Quick add on collection cards ---------- */
  document.addEventListener('click', function (e) {
    var quick = e.target.closest('[data-quick-add]');
    if (!quick) return;
    e.preventDefault();
    var id = Number(quick.getAttribute('data-variant-id'));
    if (!id) return;
    var original = quick.innerHTML;
    quick.disabled = true;
    quick.innerHTML = '<span>Adding…</span>';
    postJSON(BLK.cartAddUrl || '/cart/add.js', { items: [{ id: id, quantity: 1 }] })
      .then(function (res) {
        if (!res.ok) throw new Error('Could not add to basket');
        return refreshCart(true);
      })
      .then(function () { toast('Added to basket'); })
      .catch(function () { toast('Could not add to basket', true); })
      .finally(function () { quick.disabled = false; quick.innerHTML = original; });
  });

  /* ---------- Quantity steppers on product page ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-product-qty-step]');
    if (!step) return;
    var input = step.closest('.qty') ? $('input', step.closest('.qty')) : null;
    if (!input) return;
    var dir = Number(step.getAttribute('data-product-qty-step'));
    var next = Math.max(1, Math.min(99, (Number(input.value) || 1) + dir));
    input.value = next;
  });

  /* ---------- Filters / sort ---------- */
  $$('[data-filter-form]').forEach(function (form) {
    form.addEventListener('change', function () { form.submit(); });
  });
  $$('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      if (select.value) window.location.href = select.value;
    });
  });

  /* ---------- FAQ: close others ---------- */
  $$('[data-faq-accordion]').forEach(function (acc) {
    var items = $$('details', acc);
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (item.open) {
          items.forEach(function (other) { if (other !== item) other.open = false; });
        }
      });
    });
  });

  /* ---------- Reveal on scroll ---------- */
  var reveals = $$('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          ro.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach(function (el) { ro.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Sticky ATC trigger ---------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-sticky-atc]');
    if (trigger) {
      e.preventDefault();
      var btn = $('#ProductForm [data-atc-button]');
      if (btn) btn.click();
    }
  });

  function initYarnDropdowns() {
    $$('[data-yarn-dropdown]').forEach(function (dd) {
      var panel = dd.querySelector('[data-yarn-panel]');
      var sel = dd.querySelector('select[data-option-input]');
      if (!panel || !sel) return;
      dd.querySelectorAll('[data-yarn-option]').forEach(function (opt) {
        opt.addEventListener('click', function () {
          var v = opt.getAttribute('data-value');
          sel.value = v;
          var cur = dd.querySelector('[data-yarn-current]'); if (cur) cur.textContent = v;
          var bs = dd.querySelector('[data-yarn-button] .swatch');
          var rs = opt.querySelector('.swatch');
          if (bs && rs) bs.style.background = rs.style.background;
          dd.removeAttribute('open');
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      document.addEventListener('click', function (e) {
        if (!dd.contains(e.target)) { dd.removeAttribute('open'); }
      });
    });
  }

  /* ---------- Init ---------- */
  initProductForm();
  initYarnDropdowns();
  refreshCart(false);
  window.addEventListener('pageshow', function () { refreshCart(false); });
})();
